module.exports = __webpack_public_path__ + "img/cover-2.0506f83a.jpg";